import router from './router';
import store from './store';
// import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style

NProgress.configure({ showSpinner: false }); // NProgress Configuration

// 导航钩子 https://router.vuejs.org/zh-cn/advanced/navigation-guards.html
router.beforeEach((to, from, next) => {
  // 开启Progress
  NProgress.start();
  // const loginName = store.state.user.loginName;
  // const permCodes = store.state.user.permCodes;
  // const routerPerm = to.meta.perm;
  // // 判断是否需要的登录
  // if (!routerPerm) {
  //   // 继续执行跳转
  //   next();
  //   // 不执行之后的代码
  //   return;
  // }
  // // 判断是否登录
  // if (loginName) {
  //   if (!permCodes.includes(routerPerm)) {
  //     Message({
  //       message: '用户没有权限',
  //       type: 'error'
  //     });
  //   } else {
  //     next();
  //   }
  // } else {
  //   next({ path: '/login' });
  // }
  next();
});

router.afterEach(() => {
  // 结束Progress
  NProgress.done();
});
